<template>
  <div class="news-list-container">
    <!-- <div class="title">产业舆情新闻列表</div> -->
    <!-- <div class="row news-list-tab-input">
      <div class="news-list-tab">
        <sn-tabs :tabs="dateRangeTabs" @change="onDateRangeTabChange"></sn-tabs>
      </div>
      <div class="news-list-input">
        <input ref="input" type="text" :placeholder="placeholder" v-model.trim="searchText">
      </div>
    </div> -->
    <div v-if="showUnread" @click="onShowNewMessage" class="row unread-message">
      <img src="../../assets/img/arrow-up.svg" class="icon" alt="">
      <div class="unread-count">{{latestIndustryNewsData.length}}条新闻</div>
    </div>
    <div class="filter-tag">
      <industry-theme-news-list-filter
        :news-list-filters="newsListFilters"
        v-if="newsListFilters"
        :selected-tags="filters"
        class="filter-panel"
        @change="onFilterChange"
      ></industry-theme-news-list-filter>
    </div>
    <industry-news-list-filter-panel 
      :filters="filters" 
      @change="onFilterPanelChange"
      v-if="filters.industry.length || filters.event.length || filters.emotional.length"
    ></industry-news-list-filter-panel>
    <div class="row news-list-source-filter">
      <div class="total-count">共有{{totalCount}}条相关新闻</div>
      <div class="news-list-source-filter-right">
        <SnDatePicker @timeChange="timeChange"></SnDatePicker>
        <el-select class="select set-vertical-align" v-model="source" @change="onSourceChange" placeholder="请选择">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </div>
    </div>
    <div v-loading="isLoading">
      <div>
        <div v-infinite-scroll="loadMore" infinite-scroll-disabled="busy" infinite-scroll-distance="10">
          <theme-news-list-item v-for="(item, index) in resultData" :key="index" :data="item"></theme-news-list-item>
        </div>
      </div>
      <div class="loading" v-if="industryListData.length && resultData.length && totalCount>pageSize"><div class="loading-word">加载中...</div></div>
      <div class="loading" v-if="!industryListData.length && resultData.length || (totalCount>0 && totalCount<=pageSize)"><div class="loading-word">没有更多了</div></div>
    </div>
  </div>
</template>

<script>
import IndustryThemeNewsListFilter from '@/components/whole-network/IndustryThemeNewsListFilter';
import ThemeNewsListItem from '@/components/whole-network/ThemeNewsListItem';
import IndustryNewsListFilterPanel from '@/components/news-monitor/IndustryNewsListFilterPanel';
import QuestionQuery from '@/rest/questionQuery';
import SnDatePicker from '@/components/common/SnDatePicker';

export default {
  data() {
    return {
      scrollTopIndustryNewsTimer: null,
      latestIndustryNewsData: [],
      showUnread: false,
      industryNewsListDoc: null,

      newsListFilters: null,
      filters: {
        industry: [],
        event: [],
        emotional: []
      },
      industryId: [],
      eventId: [],
      emotionalId: [],
      filtersData: {
        industry: [],
        event: [],
        emotional: []
      },
      totalCount: 0,
      source: '全部来源',
      options: [
        {
          value: '全部来源',
          label: '全部来源'
        },
        {
          value: '官媒',
          label: '官媒'
        },
        {
          value: '公众号',
          label: '公众号'
        }
      ],
      pageSize: 20,
      type: 'industry',
      isLoading: false,
      industryListData: [],
      resultData: [],
      busy: false,
      timer: null,
      earliestNewsId: -1,
      earliestDateNum: -1,
      latestDateNum: -1,
      industryNewsListTimer: null,
      date: []
    };
  },
  methods: {
    timeChange(date) {
      this.getLatestIndustryNewsSetInterval(false);
      this.date = date || [];
      this.industryListData = [];
      this.resultData = [];
      this.earliestNewsId = -1;
      this.earliestDateNum = -1;
      this.latestDateNum = -1;
      this.getFirstIndustryNewsList();
    },
    loadMore() {
      this.busy = true;
      if (this.timer) {
        clearTimeout(this.timer);
      }
      if (this.industryListData.length) {
        this.timer = setTimeout(() => {
          this.getIndustryNewsList();
        }, 500);
      }
    },
    getIndustryNewsTags() {
      QuestionQuery.getThemeTags().then(res => {
        const emotional = [
          {
            id: '正面',
            name: '正面'
          },
          {
            id: '负面',
            name: '负面'
          },
          {
            id: '中性',
            name: '中性'
          }
        ];
        /* eslint-disable */
        this.newsListFilters = {
          industry: res,
          emotional: emotional
        };
      });
    },
    onSourceChange(res) {
      this.getLatestIndustryNewsSetInterval(false);
      this.source = res;
      this.industryListData = [];
      this.resultData = [];
      this.earliestNewsId = -1;
      this.earliestDateNum = -1;
      this.latestDateNum = -1;
      this.getFirstIndustryNewsList();
    },
    onFilterChange(filters) {
      this.getLatestIndustryNewsSetInterval(false);
      this.filters = filters;
      /* eslint-disable */
      this.industryId = this.filters.industry.map(item => {
        return item.id;
      });
      this.eventId = this.filters.event.map(item => {
        return item.id;
      });
      this.emotionalId = this.filters.emotional.map(item => {
        return item.id;
      });
      this.filtersData = {
        industry: this.industryId,
        event: this.eventId,
        emotional: this.emotionalId
      };
      this.industryListData = [];
      this.resultData = [];
      this.earliestNewsId = -1;
      this.earliestDateNum = -1;
      this.latestDateNum = -1;
      this.getFirstIndustryNewsList();
    },
    onFilterPanelChange(res) {
      this.getLatestIndustryNewsSetInterval(false);
      this.filters = res;
      /* eslint-disable */
      this.industryId = this.filters.industry.map(item => {
        return item.id;
      });
      this.eventId = this.filters.event.map(item => {
        return item.id;
      });
      this.emotionalId = this.filters.emotional.map(item => {
        return item.id;
      });
      // eslint-disable-next-line
      this.filtersData = {
        industry: this.industryId,
        event: this.eventId,
        emotional: this.emotionalId
      };
      this.industryListData = [];
      this.resultData = [];
      this.earliestNewsId = -1;
      this.earliestDateNum = -1;
      this.latestDateNum = -1;
      this.getFirstIndustryNewsList();
    },
    getLatestIndustryNewsList() {
      const params = {
        sourceGenre: this.source === '公众号' ? '微信' : this.source,
        pageSize: 15,
        themes: this.filtersData.industry,
        themeSentiments: this.filtersData.emotional,
        earliestNewsId: -1,
        earliestDateNum: -1,
        latestDateNum: this.latestDateNum,
        date: this.date
      };
      QuestionQuery.getThemeNewsList(params).then(
        res => {
          if (res.result.length) {
            this.latestDateNum = res.result[0].dateNum;
            if (this.industryNewsListDoc.scrollTop >= 0 && this.industryNewsListDoc.scrollTop <= 500) {
              this.showUnread = false;
              this.industryNewsListDoc.scrollTop = 0;
              this.resultData.unshift(...res.result);
            } else {
              this.showUnread = true;
              this.latestIndustryNewsData = this.latestIndustryNewsData.concat(res.result);
            }
          }
        },
        () => {
          this.getLatestIndustryNewsSetInterval(false);
        }
      );
    },
    onShowNewMessage() {
      this.showUnread = false;
      if (this.latestIndustryNewsData >= 100) {
        this.resultData.unshift(...this.latestIndustryNewsData);
        this.latestIndustryNewsData = [];
        this.industryNewsListDoc.scrollTop = 0;
      } else {
        this.resultData.unshift(...this.latestIndustryNewsData);
        this.latestIndustryNewsData = [];
        this.scrollTopIndustryNewsTimer = setInterval(() => {
          if (this.industryNewsListDoc.scrollTop) {
            this.industryNewsListDoc.scrollTop = this.industryNewsListDoc.scrollTop - 200;
          } else if (!this.industryNewsListDoc.scrollTop || this.industryNewsListDoc.scrollTop < 0) {
            clearInterval(this.scrollTopIndustryNewsTimer);
          }
        }, 50);
      }
    },
    getFirstIndustryNewsList() {
      const params = {
        sourceGenre: this.source === '公众号' ? '微信' : this.source,
        pageSize: this.pageSize,
        themes: this.filtersData.industry,
        themeSentiments: this.filtersData.emotional,
        earliestNewsId: this.earliestNewsId,
        earliestDateNum: this.earliestDateNum,
        latestDateNum: -1,
        date: this.date
      };
      this.isLoading = true;
      QuestionQuery.getThemeNewsList(params).then(res => {
        this.isLoading = false;
        this.industryListData = res.result;
        this.totalCount = res.totalCount;
        if (this.industryListData.length) {
          this.latestDateNum = res.result[0].dateNum;
          this.earliestNewsId = this.industryListData[this.industryListData.length - 1].newsId;
          this.earliestDateNum = this.industryListData[this.industryListData.length - 1].dateNum;
          this.resultData = this.resultData.concat(this.industryListData);
          this.busy = false;
        } else {
          this.busy = true;
        }
        this.getLatestIndustryNewsSetInterval(true);
      });
    },
    getLatestIndustryNewsSetInterval(start) {
      if (this.industryNewsListTimer) {
        clearTimeout(this.industryNewsListTimer);
      }
      if (start) {
        this.industryNewsListTimer = setTimeout(() => {
          this.getLatestIndustryNewsList();
          this.getLatestIndustryNewsSetInterval(start);
        }, 1000 * 20);
      }
    },
    getIndustryNewsList() {
      const params = {
        sourceGenre: this.source === '公众号' ? '微信' : this.source,
        pageSize: this.pageSize,
        themes: this.filtersData.industry,
        themeSentiments: this.filtersData.emotional,
        earliestNewsId: this.earliestNewsId,
        earliestDateNum: this.earliestDateNum,
        latestDateNum: -1,
        date: this.date
      };
      this.isLoading = true;
      QuestionQuery.getThemeNewsList(params).then(res => {
        this.isLoading = false;
        this.industryListData = res.result;
        this.totalCount = res.totalCount;
        if (this.industryListData.length) {
          this.earliestNewsId = this.industryListData[this.industryListData.length - 1].newsId;
          this.earliestDateNum = this.industryListData[this.industryListData.length - 1].dateNum;
          this.resultData = this.resultData.concat(this.industryListData);
          this.busy = false;
        } else {
          this.busy = true;
        }
      });
    }
  },
  components: {
    IndustryThemeNewsListFilter,
    ThemeNewsListItem,
    IndustryNewsListFilterPanel,
    SnDatePicker
  },
  mounted() {
    this.industryNewsListDoc = document.documentElement;
    this.getIndustryNewsTags();
    this.getFirstIndustryNewsList();
  },
  beforeDestroy() {
    this.getLatestIndustryNewsSetInterval(false);
  }
};
</script>

<style lang="scss" scoped>
.icon {
  width: 16px;
}
.loading {
  padding: 12px 0;
  margin: 0 auto;
  height: 10px;
  width: 772px;
  color: #666666;
  text-align: center;
}
.news-list-container {
  padding: 16px 24px 24px;
  // border-radius: 8px;
  background-color: #ffffff;
  .unread-message {
    position: fixed;
    top: 80px;
    left: 50%;
    transform: translateX(-50%);
    padding: 0 12px;
    height: 17px;
    background-color: #636772;
    border-radius: 2px;
    z-index: 1;
    cursor: pointer;
    .unread-count {
      margin-right: 4px;
      color: #ffffff;
      font-size: 12px;
      cursor: pointer;
    }
  }
  .title {
    margin-bottom: 16px;
    font-weight: 500;
    font-size: 20px;
    color: white;
  }
  .news-list-tab-input {
    justify-content: space-between;
    .news-list-input {
      input {
        width: 160px;
        height: 26px;
        padding: 0 12px;
        color: #ffffff !important;
        font-size: 14px;
        background-color: rgba(19, 18, 21, 0.4);
        border-radius: 4px;
        border: solid 2px rgba(255, 255, 255, 0.2);
        outline: none;

        // &:hover {
        //   border: solid 2px #423f43;
        // }

        &:focus {
          border: solid 2px #5f5d60;
        }
      }
      input[placeholder] {
        color: rgba(255, 255, 255, 0.4);
      }
    }
  }
  .filter-tag {
    position: relative;
    // margin: 16px 0 0;
    width: 100%;
    background-color: #f7f8fc;
  }
  .news-list-source-filter {
    justify-content: space-between;
    margin-top: 24px;
    width: 100%;
    height: 48px;
    line-height: 48px;
    border-top: 1px solid #f7f8fa;
    border-bottom: 1px solid #f7f8fa;
    .total-count {
      color: #747990;
      font-size: 12px;
    }
    .news-list-source-filter-right {
      .select {
        margin-left: 10px;
        width: 100px;
      }
    }
  }
}
/deep/.el-select .el-input__inner {
  height: 26px;
  border: none !important;
  border-radius: 2px;
  color: #464d6c;
  background-color: #f7f8fc !important;
  &:hover {
    background-color: #eaebef !important;
  }
}
/deep/.el-select .el-input .el-select__caret {
  font-weight: 900;
  color: #747990;
}
</style>
